const signpageText = {
  signin: " Giriş yap",
  signup: " Üye ol",
  signinHeader: "Fırsatlardan yararlanmak için giriş yap!",
  signupHeader: "Fırsatlardan yararlanmak için üye ol!",
  accountText1: " Hesabın var mı? ",
  accountText2: " Hesabın yok mu? ",
  signupForm: {
    email: {
      label: "Email",
      placeholder: "Email@example.com",
    },
    password: {
      label: "Şifre",
      placeholder: "Şifre",
    },
    button: "Üye ol",
  },
  signinForm: {
    email: {
      label: "Email",
      placeholder: "Email@example.com",
      button: "Üye ol",
    },
    password: {
      label: "Şifre",
      placeholder: "Şifre",
      additionalText: "Şifremi Unuttum",
    },
    button: "Giriş",
  },
};

export default signpageText;
